import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { numbersRevealAnimation } from './animations'
import { Section } from '@/types'

type NumbersProps = Section &
  Partial<{
    title: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    numbers: {
      value: string
      description: string
    }[]
  }>

const Numbers = ({
  title,
  title_variant,
  title_component,
  numbers,
  ...props
}: NumbersProps) => {
  return (
    <Motion animation={numbersRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-xl">
              <div className="col-span-2 md:col-span-3 lg:col-span-6">
                {title ? (
                  <Typography
                    variant={title_variant}
                    component={title_component}
                    className="[&_em]:text-blue-soft uppercase text-white underline"
                    data-motion-title
                  >
                    {title}
                  </Typography>
                ) : null}
              </div>
              <div className="col-span-2 md:col-span-3 lg:col-span-6">
                <div className="grid grid-cols-2 gap-x-gutter gap-y-xl md:grid-cols-4 lg:grid-cols-6">
                  {numbers?.map(({ value, description }, index) => (
                    <div
                      key={`number-${index}`}
                      className="col-span-1 md:col-span-2 lg:col-span-3"
                    >
                      <div className="grid gap-y-sm">
                        <span className="flex">
                          <span className="relative inline-flex w-[10rem] pb-[2rem]">
                            {value ? (
                              <Typography
                                variant="h1"
                                className="[&_em]:text-blue-soft text-white"
                                data-motion-value={value}
                              >
                                {value}
                              </Typography>
                            ) : null}
                            <span
                              className="absolute -bottom-[.4rem] left-0 h-[.4rem] w-full bg-white"
                              data-motion-line
                            />
                          </span>
                        </span>

                        {description ? (
                          <div className="-my-[0.5rem] overflow-hidden py-[0.5rem]">
                            <Typography
                              variant="body"
                              paragraph
                              className="text-neutral-20"
                              data-motion-description
                            >
                              {description}
                            </Typography>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default Numbers
